/**
 * Admin Results toolbar after Finance payouts are locked.
 *
 * Prize amounts are not public until Lock Results. Preview is a local
 * confirmation step. It starts false on load/reload.
 * Unlock Results pulls public prize amounts back.
 *
 *   payouts locked, results unlocked, not previewing → Preview Payouts
 *   payouts locked, results unlocked, previewing     → Lock Results + Cancel
 *   results locked                                   → Unlock Results
 */
export const getResultsAdminControls = ({
  canManage = false,
  isPayoutFinalized = false,
  isResultsFinalized = false,
  isPreviewingPayouts = false,
} = {}) => {
  if (!canManage || !isPayoutFinalized) {
    return { action: null, showCancel: false };
  }

  if (isResultsFinalized) {
    return { action: "unlock", showCancel: false };
  }

  if (isPreviewingPayouts) {
    return { action: "lock", showCancel: true };
  }

  return { action: "preview", showCancel: false };
};
